import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import Spinner from "shared/components/spinner"
import spinnerConfig from "../utils/spinner_config"

import { GetMoreSection } from "./get_more_section"
import {
  fetchSections,
  fetchBelowFoldDiscoverContent,
} from "../reducers/get_more_results"
import {
  connectionShape,
  serviceShape,
  partialStoryShape,
} from "app/lib/shared_prop_types"

import upsellPlugHOC from "./upsell_plug_hoc"

import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

export class GetMoreView extends React.Component {
  constructor(props) {
    super(props)
    props.fetchResults()
    this.limit = 1
  }

  loadMoreResults = () => {
    //hardcoding the limit for now because we only have 15 stories in Contentful
    if (this.limit < 10 && !this.props.loading && this.props.belowFoldLoaded) {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight * 0.65
      ) {
        this.props.fetchMoreResults(this.limit++)
      }
    }
  }

  componentDidMount() {
    this.props
      .fetchBelowFoldDiscoverContent()
      .then(() => this.props.fetchMoreResults(this.limit++))

    // Event should be fired on JS because same route is responsible for discover and search
    logIFTTTNextAction("page_viewed", {
      object_type: "discover",
      location_type: "discover",
      source_location_type: this.props.origin,
    })

    window.addEventListener("scroll", this.loadMoreResults, { passive: true })
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.loadMoreResults, {
      passive: true,
    })
  }

  render() {
    return (
      <div id="get-more-results">
        {this.props.getMoreSections.map((section, idx) => {
          return (
            <GetMoreSection
              key={idx}
              section={section}
              diyPath={this.props.diyPath}
            />
          )
        })}
        {this.props.loading && <Spinner config={spinnerConfig} />}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    getMoreSections: state.getMoreResults.getMoreSections,
    loading: state.getMoreResults.loading,
    origin: state.viewToggle.origin,
    diyPath: state.getMoreResults.diyPath,
    belowFoldLoaded: state.getMoreResults.belowFoldLoaded,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchResults: () => dispatch(fetchSections()),
    fetchMoreResults: offset => dispatch(fetchSections(offset)),
    fetchBelowFoldDiscoverContent: () =>
      dispatch(fetchBelowFoldDiscoverContent()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(upsellPlugHOC(GetMoreView))

GetMoreView.propTypes = {
  getMoreSections: PropTypes.arrayOf(
    PropTypes.shape({
      applets: PropTypes.arrayOf(connectionShape),
      services: PropTypes.arrayOf(serviceShape),
      stories: PropTypes.arrayOf(partialStoryShape),
      servicesOffset: PropTypes.number,
      appletsOffset: PropTypes.number,
      storiesOffset: PropTypes.number,
    })
  ),
  fetchResults: PropTypes.func,
  fetchMoreResults: PropTypes.func,
  fetchBelowFoldDiscoverContent: PropTypes.func,
  belowFoldLoaded: PropTypes.bool,
  loading: PropTypes.bool,
  diyPath: PropTypes.string,
  origin: PropTypes.string,
}

GetMoreView.defaultProps = {
  getMoreSections: [],
  loading: false,
}
